<template>
  <v-btn
    class="mx-0"
    :small="small"
    :light="light"
    @click.prevent="pdfSoloCall"
    :loading="loading"
    :disabled="loading"
    ><v-icon :small="small" class="mr-2">mdi-file-pdf</v-icon> Solo Ext</v-btn
  >
</template>

<script>
import constants from '@/data/constants'
import pdfMake from 'pdfmake/build/pdfmake'
// import pdfFonts from 'pdfmake/build/vfs_fonts'
// import { serverBus } from '../../main'
import _ from 'lodash'
import ListsMixin from '@/mixins/ListsMixin'
import { dynamicSort } from '@/utils/artworkSort'

// pdfMake.vfs = pdfFonts.pdfMake.vfs

export default {
  mixins: [ListsMixin],
  props: [
    'item',
    'small',
    'light',
    'title',
    'subtitle',
    'created_by',
    'created_at',
    'page_no',
    'showNoOfArtworks',
    'sort',
    'subsort',
    'columns',
  ],
  data: () => ({
    // output_fields: [],
    constants: constants,
    loading: false,
    outputFields: ['classification', 'ownership'],
    output_fields: [],
    list_settings: {
      use_current_selection: false,
      use_current_list_selection: false,
      financial_information: false,
      image: false,
      compact: false,
      table: true,
      view: 'table',
      sort: 'sort_name',
      add_empty_column: false,
    },
    add_empty_column: false,
    imageSize1: '240',
    imageSize2: '240',
    pdf_artworks: [],
  }),
  // props: ['list', 'index', 'se', 'disable'],
  // created () {
  //   this.pdf(false)
  // },
  mounted() {
    this.output_fields = this.columns
    // Object.assign(
    //   [],
    //   this.$store.state.currentOutputFieldsSelection
    // )
  },
  methods: {
    pdfSoloCall(full) {
      this.loading = true
      setTimeout(
        function () {
          setTimeout(
            function () {
              this.pdf(full)
              this.loading = false
            }.bind(this),
            0
          )
        }.bind(this),
        500
      )
    },
    pdf(full) {
      // console.log(this.columns)
      if (!full) {
        this.show_preview_pane = true
      }
      var heights = 700
      var margins = [0, 0, 0, 0]
      var image = this.image
      var created = new Date().toISOString().slice(0, 10)
      var username = this.c_user.abb
      var list_name = this.title ? this.title.toUpperCase() : 'LIST'
      var subtitle = this.subtitle ? this.subtitle.toUpperCase() : ''
      var full_title = list_name + (subtitle != '' ? '\n' + subtitle : '')
      var full_title_style = subtitle != '' ? 'titleS' : 'title'
      var image_size = [this.imageSize1, this.imageSize2]
      var output_fields = this.columns
      var imageSize3 = parseInt(this.imageSize2)
      // var rectPosX = 220 - imageSize3
      var use_current_selection = this.use_current_selection
      // var noOfArtworks = 0
      var logoImage = this.getLogo()
      logoImage = logoImage.split('\n')
      var tempArtworks = []

      if (this.item && this.item.artworks.length > 0) {
        this.pdf_artworks = this.item.artworks
      } else {
        // console.log(this.use_current_selection)
        if (use_current_selection == true) {
          // this.pdf_artworks = Object.assign([], this.$store.state.currentSelection)
          if (this.$store.state.currentSelection.length > 0) {
            this.pdf_artworks = Object.assign(
              [],
              this.ids2o(this.$store.state.currentSelection)
            ).sort(dynamicSort(this.sort))
          } else {
            this.pdf_artworks = Object.assign(
              [],
              this.$store.state.artworks
            ).sort(dynamicSort(this.sort))
          }
        } else {
          if (this.$store.state.filterResults) {
            var objs = this.ids2o(this.$store.state.filterResults)
            this.pdf_artworks = objs.sort(dynamicSort(this.sort))
          } else {
            this.pdf_artworks = Object.assign(
              [],
              this.$store.state.artworks
            ).sort(dynamicSort(this.sort))
          }
        }
      }

      // this.pdf_artworks = this.pdf_artworks.slice(0,5)
      var artworks = this.pdf_artworks

      if (this.sort == 'collection') {
        var collectionsIds = [1, 12, 15, 6, 7, 17, 10]
        this.pdf_artworks = this.customDoubleSort(
          this.pdf_artworks,
          collectionsIds,
          'ownership',
          this.subsort
        )
      } else {
        this.pdf_artworks = this.pdf_artworks.sort(
          dynamicSort(this.sort, this.subsort)
        )
      }
      let transformedData = this.formatListData(
        this.pdf_artworks,
        output_fields
      )
      // console.log(transformedData)

      // console.log(transformedData)

      const creationDate = () => new Date()

      function getImagefromAPI(top_photo_id, id) {
        var request = new XMLHttpRequest()
        var requestER = new XMLHttpRequest()
        var src = ''
        // console.log('id')
        // console.log(id)
        // console.log(top_photo_id)
        // console.log('id')
        if (id) {
          // console.log(id)
          src = 'https://api.tb-cms.org/vueimages/' + id + '_big.txt'
          request.open('GET', src, false)
          request.send(null)
          if (request.readyState === 4) {
            if (request.status === 200 && request.statusText === 'OK') {
              // console.log('status OK')
              var type = request.getResponseHeader('Content-Type')
              if (type.indexOf('text') !== 1) {
                // console.log('text OK')
                return request.responseText
              }
            } else {
              // console.log('status not OK')
              requestER.open(
                'GET',
                'https://api.tb-cms.org/vueimages/ir.txt',
                false
              )
              requestER.send(null)
              if (requestER.readyState === 4) {
                // console.log('status not OK - 4')
                if (requestER.status === 200 && requestER.statusText === 'OK') {
                  // console.log('status not OK - 4 - OK')
                  var type = requestER.getResponseHeader('Content-Type')
                  if (type.indexOf('text') !== 1) {
                    return requestER.responseText
                  }
                } else {
                  return ''
                }
              }
            }
          }
        } else {
          // console.log('ir')
          requestER.open(
            'GET',
            'https://api.tb-cms.org/vueimages/ir.txt',
            false
          )
          requestER.send(null)
          if (requestER.readyState === 4) {
            // console.log('status not OK - 4')
            if (requestER.status === 200 && requestER.statusText === 'OK') {
              // console.log('status not OK - 4 - OK')
              var type = requestER.getResponseHeader('Content-Type')
              if (type.indexOf('text') !== 1) {
                return requestER.responseText
              }
            } else {
              return ''
            }
          }
        }
      }

      const createDocumentDefinition = (...contentParts) => {
        const baseDocDefinition = {
          pageMargins: [40, 40, 40, 40],
          defaultFileName: 'list.pdf',
          pageSize: 'A4',
          // footer: (currentPage, pageCount) => {
          //   return {
          //     ...(this.page_no == true && {
          //       text:
          //         'Page ' +
          //         currentPage.toString() +
          //         ' of ' +
          //         pageCount.toString(),
          //       alignment: 'center',
          //       fontSize: 7
          //     })
          //     // text: `Page ${currentPage.toString()} of ${pageCount.toString()}`, alignment: 'center', fontSize: 7
          //   }
          // },
          info: {
            title: list_name,
            author: username,
            subject: list_name,
            keywords: 'artwork names, artist names',
            creationDate: created,
          },
          styles: {
            title: {
              fontSize: 14,
              all_caps: true,
              alignment: 'right',
              bold: true,
              margin: [0, 33, 0, 0],
            },
            titleS: {
              fontSize: 14,
              all_caps: true,
              alignment: 'right',
              margin: [0, 33, 0, 0],
            },
            titleSub: { fontSize: 9, all_caps: true, alignment: 'right' },
            titleDate: { fontSize: 9, alignment: 'right', bold: false },
            createdAt: { fontSize: 9, alignment: 'right' },
            createdBy: { fontSize: 9, alignment: 'right' },
            bold: { fontSize: 9, bold: false },
            normal: { fontSize: 9, bold: false },
            artwork_title: { fontSize: 9, bold: true, margin: [0, 0, 0, 0] },
            artwork_title_top: {
              fontSize: 9,
              bold: false,
              margin: [0, 0, 0, 0],
            },
            artist_name: { fontSize: 9, italic: true, margin: [0, 25, 0, 0] },
            image: { alignment: 'center', margin: [0, 0, 0, 0] },
            logo: { alignment: 'left', margin: [0, 0, 0, 40] },
          },
          content: [
            // {
            //   columns: [
            //     // { text: list_name, style: 'title', width: 'auto' },
            //     // {
            //     //   text:
            //     //     (this.created_by == true
            //     //       ? 'Created by : ' + username
            //     //       : '') +
            //     //     (this.created_at == true ? '\n' + created : '') ,
            //     //   style: 'createdBy'
            //     // }
            //     // { text: ((this.showNoOfArtworks == true) ? 'No. of Artworks: '  + this.pdf_artworks.length : ''), style: 'createdBy'}
            //     // {...(this.created_by == true) && { text: '\nCreated by ' + username, style: 'createdBy'}},
            //     // {...(this.created_at == true) && { text: created, style: 'createdAt'}}
            //   ]
            // },
            // { text: `${this.subtitle}\n\n`, style: 'titleSub' }
          ],
        }
        const docDefinition = JSON.parse(JSON.stringify(baseDocDefinition))
        // docDefinition.footer = baseDocDefinition.footer
        docDefinition.content.push(...contentParts)
        // console.log(contentParts)
        // console.log(docDefinition)
        return docDefinition
      }

      var rowData = function rowData(a) {
        var stack = {
          stack: [],
          stack2: [],
        }
        // var stacks = {
        //   stack: []
        // }
        // stacks.stack.push({
        //   text: list_name, style: 'title', width: '*'
        // }),
        // stacks.stack.push({
        //   text: subtitle, style: 'title', width: '*'
        // })
        var columns = output_fields
        // this.$store.state.selected_columns_for_pdf
        // ['title','accession_number'];
        // console.log(artworks[0]['title'])
        // console.log(a['title'])
        stack.stack.push(
          // { image: logoImage, fit: [170, 90], style: 'logo', width: '*' }
          {
            columns: [
              { image: logoImage, fit: [180, 80], style: 'logo', width: '*' },
              {
                text:
                  a['title'] ===
                  artworks[0]['title'] +
                    ', ' +
                    artworks[0]['production_date_new']
                    ? full_title
                    : '',
                style: full_title_style,
                width: '*',
              },
              // { text: currentPage, style: 'title', width: '*' },
              // {
              //   text:
              //     'Created by : ' + username +
              //     '\nNo. of Artworks: ' + pdf_artworks.length,
              //   style: 'createdBy'
              // }
              // { text: ((this.showNoOfArtworks == true) ? 'No. of Artworks: '  + this.pdf_artworks.length : ''), style: 'createdBy'}
              // {...(this.created_by == true) && { text: '\nCreated by ' + username, style: 'createdBy'}},
              // {...(this.created_at == true) && { text: created, style: 'createdAt'}}
            ],
            // text: `${subtitle}\n\n`, style: 'titleSub'
          }
        ),
          stack.stack.push({
            text: a['accession_number'],
            style: 'artwork_title_top',
          })
        stack.stack.push({ text: a['full_name'], style: 'artwork_title' })
        stack.stack.push({ text: a['title'], style: 'artwork_title' })
        stack.stack.push({ text: a['subtitle'], style: 'artwork_title' })
        // stack.stack.push({ text: currentPage, style: 'artwork_title' })

        // console.log('columns')
        // console.log(columns)
        columns.forEach((column, index) => {
          var columnData = a[column.id]
          var cp = []
          if (columnData != null && columnData.trim().length != 0) {
            stack.stack.push({ text: columnData, style: 'artwork_title' })
          }
        })

        var imagefromAPI = getImagefromAPI(a.top_photo, a.top_photo_id)
        imagefromAPI = imagefromAPI.split('\n')
        if (imagefromAPI.length == 2) {
          imagefromAPI = imagefromAPI.filter(function (el) {
            return el != ''
          })
        }
        stack.stack.push({
          margins: [0, 0, 0, 0],
          image: imagefromAPI,
          fit: image_size,
          style: 'image',
          absolutePosition: { x: 290, y: 0 },
        })

        return stack
      }

      createPdfDoc()

      function createPdfDoc() {
        const fontSize = 6

        var tableBody = function tableBody(dataRows) {
          // console.log(currentPage)
          var body = []
          dataRows.forEach(function (row, index) {
            var tableRow = []

            tableRow.push(rowData(row, transformedData))
            // console.log(tableRow)

            body.push(tableRow)
          })
          return body
        }
        var tableColumnWidths = ['*']
        var tableData = {
          layout: 'noBorders',
          table: {
            heights: heights,
            dontBreakRows: true,
            margins: margins,
            widths: tableColumnWidths,
            body: tableBody(transformedData),
          },
        }
        var docDefinition = createDocumentDefinition(tableData)

        if (full == false) {
          const pdfDocGenerator = pdfMake.createPdf(docDefinition)

          // function download() {
          //   pdfDocGenerator.download('A4-list.pdf');
          // }
          pdfDocGenerator.getDataUrl((dataUrl) => {
            const targetElement = document.querySelector('#pdfV')
            // const iframe = document.createElement('iframe')
            targetElement.src = dataUrl
            // targetElement.appendChild(iframe)
            // this.loading = false
          })
        } else {
          if (list_name) {
            var t = list_name
          } else {
            var t = 'listSolo.pdf'
          }
          // this.loading = false
          pdfMake.createPdf(docDefinition).download(t)
        }
        // this.loading = false
      }
      // this.loading = false
    },
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/lists/SoloExt.vue